'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditSubject(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }, {
        id: 'delete',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                {
                    iconClassName: 'material-icons',
                    onClick: function onClick() {
                        return removeSubject(col.original, props);
                    }
                },
                'delete'
            );
        }
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.subjects,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados assuntos para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true,
            defaultFilterMethod: search
        })
    );
};

function search(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
}

function removeSubject(subject, props) {
    var confirm = window.confirm('Voc\xEA deseja deletar o assunto ' + subject.name + '?');

    if (confirm) {
        props.removeSubject(subject.id);
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9zdWJqZWN0cy9TdWJqZWN0c0xpc3QuanMiXSwibmFtZXMiOlsicHJvcHMiLCJjb2x1bW5zIiwiaWQiLCJ3aWR0aCIsIkNlbGwiLCJjb2wiLCJvbkNsaWNrRWRpdFN1YmplY3QiLCJvcmlnaW5hbCIsIkhlYWRlciIsImFjY2Vzc29yIiwicmVtb3ZlU3ViamVjdCIsInN1YmplY3RzIiwibG9hZGluZyIsInNlYXJjaCIsImZpbHRlciIsInJvdyIsImNvbHVtbiIsInBpdm90SWQiLCJ1bmRlZmluZWQiLCJTdHJpbmciLCJ0b0xvd2VyQ2FzZSIsImluY2x1ZGVzIiwidmFsdWUiLCJzdWJqZWN0IiwiY29uZmlybSIsIndpbmRvdyIsIm5hbWUiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O2tCQUVlLFVBQUNBLEtBQUQsRUFBVzs7QUFFekIsUUFBTUMsVUFBVSxDQUFDO0FBQ1ZDLFlBQUksTUFETTtBQUVWQyxlQUFPLEVBRkc7QUFHVkMsY0FBTSxjQUFDQyxHQUFEO0FBQUEsbUJBQVM7QUFBQyxvQ0FBRDtBQUFBLGtCQUFZLGVBQWMsZ0JBQTFCLEVBQTJDLFNBQVM7QUFBQSwrQkFBTUwsTUFBTU0sa0JBQU4sQ0FBeUJELElBQUlFLFFBQUosQ0FBYUwsRUFBdEMsQ0FBTjtBQUFBLHFCQUFwRDtBQUFBO0FBQUEsYUFBVDtBQUFBO0FBSEksS0FBRCxFQUlWO0FBQ0NNLGdCQUFRLElBRFQ7QUFFQ0Msa0JBQVUsSUFGWDtBQUdDTixlQUFPO0FBSFIsS0FKVSxFQVFiO0FBQ0ZLLGdCQUFRLE1BRE47QUFFSUMsa0JBQVU7QUFGZCxLQVJhLEVBWWhCO0FBQ09QLFlBQUksUUFEWDtBQUVPQyxlQUFPLEVBRmQ7QUFHT0MsY0FBTSxjQUFDQyxHQUFEO0FBQUEsbUJBQ1g7QUFBQyxvQ0FBRDtBQUFBO0FBQ0MsbUNBQWMsZ0JBRGY7QUFFQyw2QkFBUztBQUFBLCtCQUFNSyxjQUFjTCxJQUFJRSxRQUFsQixFQUE0QlAsS0FBNUIsQ0FBTjtBQUFBO0FBRlY7QUFBQTtBQUFBLGFBRFc7QUFBQTtBQUhiLEtBWmdCLENBQWhCOztBQXdCRyxXQUNJO0FBQUE7QUFBQTtBQUNJLHNDQUFDLG9CQUFEO0FBQ0ksa0JBQU1BLE1BQU1XLFFBRGhCO0FBRUkscUJBQVNWLE9BRmI7QUFHSSxxQkFBU0QsTUFBTVksT0FIbkI7QUFJSSwwQkFBYSxVQUpqQjtBQUtJLHNCQUFTLFlBTGI7QUFNSSx5QkFBWSxlQU5oQjtBQU9JLHdCQUFXLG9EQVBmO0FBUUksc0JBQVMsV0FSYjtBQVNJLG9CQUFPLElBVFg7QUFVSSxzQkFBUyxRQVZiO0FBV0ksc0NBWEo7QUFZSSxtQkFBTyxHQVpYO0FBYUksNkJBQWlCLEVBYnJCO0FBY0ksNEJBZEo7QUFlSSxpQ0FBcUJDO0FBZnpCO0FBREosS0FESjtBQXFCSCxDOztBQUVELFNBQVNBLE1BQVQsQ0FBZ0JDLE1BQWhCLEVBQXdCQyxHQUF4QixFQUE2QkMsTUFBN0IsRUFBcUM7QUFDakMsUUFBTWQsS0FBS1ksT0FBT0csT0FBUCxJQUFrQkgsT0FBT1osRUFBcEM7QUFDQSxXQUFPYSxJQUFJYixFQUFKLE1BQVlnQixTQUFaLEdBQXlCQyxPQUFPSixJQUFJYixFQUFKLENBQVAsRUFBZ0JrQixXQUFoQixFQUFELENBQWdDQyxRQUFoQyxDQUF5Q1AsT0FBT1EsS0FBUCxDQUFhRixXQUFiLEVBQXpDLENBQXhCLEdBQStGLElBQXRHO0FBQ0g7O0FBRUQsU0FBU1YsYUFBVCxDQUF1QmEsT0FBdkIsRUFBZ0N2QixLQUFoQyxFQUF1QztBQUN0QyxRQUFNd0IsVUFBVUMsT0FBT0QsT0FBUCx1Q0FBZ0RELFFBQVFHLElBQXhELE9BQWhCOztBQUVBLFFBQUlGLE9BQUosRUFBYTtBQUNaeEIsY0FBTVUsYUFBTixDQUFvQmEsUUFBUXJCLEVBQTVCO0FBQ0E7QUFDRCIsImZpbGUiOiJTdWJqZWN0c0xpc3QuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUmVhY3RUYWJsZSBmcm9tICdyZWFjdC10YWJsZSc7XG5pbXBvcnQgSWNvbkJ1dHRvbiBmcm9tICdtYXRlcmlhbC11aS9JY29uQnV0dG9uJztcblxuZXhwb3J0IGRlZmF1bHQgKHByb3BzKSA9PiB7XG5cdFxuXHRjb25zdCBjb2x1bW5zID0gW3tcbiAgICAgICAgaWQ6ICdlZGl0JyxcbiAgICAgICAgd2lkdGg6IDYyLFxuICAgICAgICBDZWxsOiAoY29sKSA9PiA8SWNvbkJ1dHRvbiBpY29uQ2xhc3NOYW1lPVwibWF0ZXJpYWwtaWNvbnNcIiBvbkNsaWNrPXsoKSA9PiBwcm9wcy5vbkNsaWNrRWRpdFN1YmplY3QoY29sLm9yaWdpbmFsLmlkKX0+ZWRpdDwvSWNvbkJ1dHRvbj5cbiAgICB9LCB7XG4gICAgICAgIEhlYWRlcjogJ0lkJyxcbiAgICAgICAgYWNjZXNzb3I6ICdpZCcsXG4gICAgICAgIHdpZHRoOiAyNDBcblx0fSwge1xuXHRcdEhlYWRlcjogJ05vbWUnLFxuICAgICAgICBhY2Nlc3NvcjogJ25hbWUnLFxuXHR9LFxuXHR7XG4gICAgICAgIGlkOiAnZGVsZXRlJyxcbiAgICAgICAgd2lkdGg6IDYyLFxuICAgICAgICBDZWxsOiAoY29sKSA9PiBcblx0XHRcdDxJY29uQnV0dG9uIFxuXHRcdFx0XHRpY29uQ2xhc3NOYW1lPVwibWF0ZXJpYWwtaWNvbnNcIiBcblx0XHRcdFx0b25DbGljaz17KCkgPT4gcmVtb3ZlU3ViamVjdChjb2wub3JpZ2luYWwsIHByb3BzKX1cblx0XHRcdD5cblx0XHRcdFx0ZGVsZXRlXG5cdFx0XHQ8L0ljb25CdXR0b24+XG5cdH1dO1xuXG4gICAgcmV0dXJuIChcbiAgICAgICAgPGRpdj5cbiAgICAgICAgICAgIDxSZWFjdFRhYmxlXG4gICAgICAgICAgICAgICAgZGF0YT17cHJvcHMuc3ViamVjdHN9XG4gICAgICAgICAgICAgICAgY29sdW1ucz17Y29sdW1uc31cbiAgICAgICAgICAgICAgICBsb2FkaW5nPXtwcm9wcy5sb2FkaW5nfVxuICAgICAgICAgICAgICAgIHByZXZpb3VzVGV4dD1cIkFudGVyaW9yXCJcbiAgICAgICAgICAgICAgICBuZXh0VGV4dD1cIlByw7N4aW1hXCJcbiAgICAgICAgICAgICAgICBsb2FkaW5nVGV4dD1cIkNhcnJlZ2FuZG8uLi5cIlxuICAgICAgICAgICAgICAgIG5vRGF0YVRleHQ9XCJOw6NvIGZvcmFtIGVuY29udHJhZG9zIGFzc3VudG9zIHBhcmEgZXN0ZSBmaWx0cm9cIlxuICAgICAgICAgICAgICAgIHBhZ2VUZXh0PVwiUMOhZ2luYVwiXG4gICAgICAgICAgICAgICAgb2ZUZXh0PVwiZGVcIlxuICAgICAgICAgICAgICAgIHJvd3NUZXh0PVwibGluaGFzXCJcbiAgICAgICAgICAgICAgICBzaG93UGFnaW5hdGlvbkJvdHRvbVxuICAgICAgICAgICAgICAgIHdpZHRoPXsxMDB9XG4gICAgICAgICAgICAgICAgZGVmYXVsdFBhZ2VTaXplPXsxMH1cbiAgICAgICAgICAgICAgICBmaWx0ZXJhYmxlXG4gICAgICAgICAgICAgICAgZGVmYXVsdEZpbHRlck1ldGhvZD17c2VhcmNofVxuICAgICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgKTtcbn07XG5cbmZ1bmN0aW9uIHNlYXJjaChmaWx0ZXIsIHJvdywgY29sdW1uKSB7XG4gICAgY29uc3QgaWQgPSBmaWx0ZXIucGl2b3RJZCB8fCBmaWx0ZXIuaWQ7XG4gICAgcmV0dXJuIHJvd1tpZF0gIT09IHVuZGVmaW5lZCA/IChTdHJpbmcocm93W2lkXSkudG9Mb3dlckNhc2UoKSkuaW5jbHVkZXMoZmlsdGVyLnZhbHVlLnRvTG93ZXJDYXNlKCkpIDogdHJ1ZTtcbn1cblxuZnVuY3Rpb24gcmVtb3ZlU3ViamVjdChzdWJqZWN0LCBwcm9wcykge1xuXHRjb25zdCBjb25maXJtID0gd2luZG93LmNvbmZpcm0oYFZvY8OqIGRlc2VqYSBkZWxldGFyIG8gYXNzdW50byAke3N1YmplY3QubmFtZX0/YCk7XG5cdFxuXHRpZiAoY29uZmlybSkge1xuXHRcdHByb3BzLnJlbW92ZVN1YmplY3Qoc3ViamVjdC5pZCk7XG5cdH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/components/subjects/SubjectsList.js
// module id = 2571
// module chunks = 0